<div class="modal-header">
  <div class="modal-header-x" (click)="bsModalRef.hide()">
    <i-feather name="x"></i-feather>
  </div>
</div>
<diamonds-details [postHashHex]="postHashHex"></diamonds-details>
